import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'

import TreeTable from 'vue-table-with-tree-grid'

import LicenseKeyboard from 'vue-license-keyboard'
import 'vue-license-keyboard/lib/vue-license-keyboard.css'

import VueCookies from 'vue-cookies'

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// 导入富文本编辑器样式
// require styles
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// 导入NProgress
// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
import Axios from 'axios'

Vue.use(VueCookies)

// 车牌输入键盘
Vue.use(LicenseKeyboard)

// 使用MintUI
Vue.use(MintUI)

// 配置请求的根路径
// Axios.defaults.baseURL = 'http://127.0.0.1:8888/api/private/v1/'
Axios.defaults.baseURL = '/agent/api/merchant/'
// Axios.defaults.baseURL = '/agent/api/merchant/'
// Axios.interceptors.request.use(config => {
//   NProgress.start()
//   config.headers.Authorization = window.sessionStorage.getItem('token')
//   return config
// })
// Axios.interceptors.response.use(config => {
//   NProgress.done()
//   return config
// })
Vue.prototype.$http = Axios

Vue.config.productionTip = false

// 注册插件tree-table
Vue.component('tree-table', TreeTable)
// 将富文本注册为全局可用的组件
Vue.use(VueQuillEditor /* { default global options } */)

Vue.filter('dateFormat', function (orignVal) {
  const dt = new Date(orignVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

Vue.filter('dateFormatYMD', function (orignVal) {
  const dt = new Date(orignVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  return `${y}-${m}-${d}`
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
